import { strict as assert } from 'assert';
import { FormData, ProductData, SheetData } from "../stolarz-form/stolarz_form_types";

// settings for "Import standardowy" in
const logicYes: string = '+';
const logicNo: string = '-';
const csvSeparator: string = ';';

const Zlecenia = '[~(Z)~]'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Order = Zlecenia
type OrderType = {
    _type: '[~(Z)~]';
    number: string | null;
    date: Date | string | null;
    name: string;
    undocumentedField: string;
    discount: number;
    description: string;
    dueDate: Date | string | null;
    businessPartnerAddress: string;
    status: 0 | 1 | 2 | 3 | 4 | null | number;
    isDeadlineSet: boolean | null;
}
const isOrderType = (value: { _type: string }): value is OrderType => {
    return value._type === Order
};


const ZleceniaProdukt = '[~(ZV)~]'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const OrderProduct = ZleceniaProdukt
type OrderProductType = {
    _type: '[~(ZV)~]';
    code: string;
    name: string;
    description: string;
    number_of_elements: number;
    price: number | null;
    // """Todo do not use float for money"""
    automatic_price: boolean;
    different_orders: boolean;
    weight_export_only: number | null;

    //  photo: NoneOrStr
    //  drawing: NoneOrStr
}
const isOrderProductType = (value: { _type: string }): value is OrderProductType => {
    return value._type === ZleceniaProdukt
};



const Positions = "[~(I)~]"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Pozycje = Positions
type PositionsType = {
    _type: '[~(I)~]';
    // """Zlecenie - Produkty - Pozycje """

    magazine_product_code: string,
    // """Must exist in Optimik 3 before import. Optimik will propt to create it."""
    accessory_code: string,
    // """Must exist in Optimik 3 before import. Optimik will cacel import."""
    code: string,
    name: string,
    description: string,
    number: number,
    keep_graining: boolean
    // """Zachowaj usłojenie"""
    length: number,  // # todo ? multiline with numbers
    width: number,
    code_for_edge_A: string,
    accessory_code_edge_A: string,
    export_only_thickness_edge_A: string | number // todo should be number only
    code_for_edge_B: string,
    accessory_code_edge_B: string,
    export_only_thickness_edge_B: string | number,
    code_for_edge_C: string,
    accessory_code_edge_C: string,
    export_only_thickness_edge_C: string | number,
    code_for_edge_D: string,
    accessory_code_edge_D: string,
    export_only_thickness_edge_D: string | number,
    additional_thickness: number | null,
    external_CNC_command: string,
    do_not_match_element_dimensions: boolean,
    export_only_thickness_width: number,
    drawing: string,
    package_number: number,
    accessory_code_1: string,
    number_of_accessory_code_1: number,
    accessory_1_package_number: number,
    accessory_code_2: string,
    number_of_accessory_code_2: number,
    accessory_2_package_number: number,
}
const isPositionsType = (value: { _type: string }): value is PositionsType => {
    return value._type === Positions
};

function toOptimikCompatibleCsv(value: Array<string | boolean | number | null | Date>): string[] {
    const result = value.map((element: string | boolean | number | null | Date) => {
        if (element instanceof Date) {
            return "";
        } else if (element === null) {
            return "";
        } else if (typeof element === "string") {
            if (!element.includes("\n")) {
                return element;
            }
            element = element.replaceAll(";", ",")
            return `"${element}"`
        } else if (typeof element === "boolean") {
            return element ? logicYes : logicNo;
        } else if (typeof element === "number") {
            return element.toString().replace(".", ",");
        } else {
            console.error("unknown element", element)
            return "";
        }
    })
    return result;
}

export function removePLChars(s: string): string {
    return s
        .replaceAll("ń", "n")
        .replaceAll("ó", "o")
        .replaceAll("ł", "l")
        .replaceAll("ż", "z")
        .replaceAll("ą", "a")
        .replaceAll("ę", "e")
        .replaceAll("ć", "ć")
        .replaceAll("Ń", "N")
        .replaceAll("Ó", "O")
        .replaceAll("Ł", "L")
        .replaceAll("Ż", "Z")
        .replaceAll("Ą", "A")
        .replaceAll("Ę", "E")
        .replaceAll("Ć", "Ć");
}
export function jsonToOptimik3(data: FormData): string {
    if (data.products === undefined) { // ugly workaround
        return "";
    }
    let result = "";
    result += Zlecenia;
    result += "\r\n";
    const date = new Date();
    const order: OrderType = {
        _type: Order,
        businessPartnerAddress: "",
        date: null,
        description: removePLChars(data.summary + `\n${data.name}\n${data.email}, nip: ${data.nip}\n${data.postalCode} ${data.city}, ${data.address}`), // todo handle new line 
        dueDate: null,
        isDeadlineSet: null,
        discount: 0,
        undocumentedField: "",
        name: removePLChars(`${data.name} ${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()} ${date.getHours()}:${date.getMinutes()}`),
        number: null,
        status: null // 0 - not realized
    };
    const orderList = [order.number, order.date, order.name, order.description,
    order.undocumentedField, // order (not explained in docs)
    order.dueDate,
    order.discount, // discount (number, +-320.00)
    order.businessPartnerAddress, // business partner address
    order.status, order.isDeadlineSet || false
    ]
    assert(orderList.length === 10, `optimik3 help specifies 10 fields, got ${orderList.length}`)

    result += toOptimikCompatibleCsv(Object.values(orderList)).join(csvSeparator)
    result += "\r\n";

    for (const product of data.products) {
        const orderProduct: OrderProductType = {
            _type: OrderProduct,
            automatic_price: false,
            code: "",
            description: "",
            different_orders: false,
            weight_export_only: null,
            name: removePLChars(product.productName),
            number_of_elements: product.amount,
            price: null
        }
        const orderProductList = [orderProduct.code, orderProduct.name, orderProduct.description, orderProduct.number_of_elements, orderProduct.price, orderProduct.automatic_price, orderProduct.different_orders, orderProduct.weight_export_only]
        assert(orderProductList.length === 8, `optimik3 help specifies 8 obligatory fields, got ${orderProductList.length}. Up to 10 fields are specified. Its a bit of a mess.`)
        result += ZleceniaProdukt;
        result += "\r\n";
        result += toOptimikCompatibleCsv(Object.values(orderProductList)).join(csvSeparator)
        result += "\r\n";
        if (product.sheets === undefined) {
            continue
        }
        for (const sheetData of product.sheets) {
            const sheet: PositionsType = {
                _type: Positions,
                accessory_1_package_number: 0,
                accessory_2_package_number: 0,
                accessory_code: "",
                accessory_code_1: "",
                accessory_code_2: "",
                accessory_code_edge_A: "",
                accessory_code_edge_B: "",
                accessory_code_edge_C: "",
                accessory_code_edge_D: "",
                additional_thickness: null, // important !
                code: sheetData.materialCode,
                code_for_edge_B: sheetData.edgeLeft.edgeCode,
                code_for_edge_A: sheetData.edgeUp.edgeCode,
                code_for_edge_D: sheetData.edgeRight.edgeCode,
                code_for_edge_C: sheetData.edgeDown.edgeCode,
                description: removePLChars(sheetData.itemComment),
                do_not_match_element_dimensions: false,
                drawing: "",
                export_only_thickness_width: 0,
                export_only_thickness_edge_A: "",
                export_only_thickness_edge_B: "",
                export_only_thickness_edge_C: "",
                export_only_thickness_edge_D: "",
                external_CNC_command: "0",
                keep_graining: sheetData.useGrain,
                length: sheetData.length,
                magazine_product_code: "",
                name: removePLChars(sheetData.itemName),
                number: sheetData.amount,
                number_of_accessory_code_1: 0,
                number_of_accessory_code_2: 0,
                package_number: 0,
                width: sheetData.width,
            }
            const sheetList = [
                sheet.code, // this is the most important one
                sheet.accessory_code,
                sheet.magazine_product_code,
                sheet.name,
                sheet.description,
                sheet.number,
                sheet.keep_graining,
                sheet.length,
                sheet.width,

                sheet.code_for_edge_A,
                sheet.accessory_code_edge_A,
                sheet.export_only_thickness_edge_A,
                sheet.code_for_edge_B,
                sheet.accessory_code_edge_B,
                sheet.export_only_thickness_edge_B,
                sheet.code_for_edge_C,
                sheet.accessory_code_edge_C,
                sheet.export_only_thickness_edge_C,
                sheet.code_for_edge_D,
                sheet.accessory_code_edge_D,
                sheet.export_only_thickness_edge_D,

                sheet.additional_thickness,
                sheet.external_CNC_command,
                null, // dummy to make syntax correct... Undocumented?
                sheet.do_not_match_element_dimensions,
                sheet.export_only_thickness_width,
                sheet.drawing,
                sheet.package_number,
                sheet.accessory_code_1,
                sheet.number_of_accessory_code_1,
                sheet.accessory_1_package_number,
                sheet.accessory_code_2,
                sheet.number_of_accessory_code_2,
                sheet.accessory_2_package_number,
            ]
            result += Positions;
            result += "\r\n";
            result += toOptimikCompatibleCsv(Object.values(sheetList)).join(csvSeparator)
            result += "\r\n";
        }
    }
    return result;
}

function fromOptimikBoolean(element: string | null): boolean {
    if (element === null || element === undefined || element === "") {
        return false;
    }
    if (element === "+") {
        return true;
    } else if (element === "-") {
        return false;
    }
    console.warn("Bad boolean: ", element)
    return false;
}

function fromOptimikNumber(element: string | null): number {
    if (element === null || element === "" || element === undefined) {
        return 0;
    } else if (element.match("[\\d]+,?[\\d]*")) {
        return parseFloat(element.replace(",", "."));
    }
    console.warn("Bad number: ", element)
    return 0;
}

function fromOptimikString(element: string | null): string {
    if (!element) {
        return "";
    } else if (element.startsWith("\"") && element.endsWith("\"")) { // mulitline string
        return element.substring(1, element.length - 2)
    }
    return element;
}

type ParseResult = (OrderType | OrderProductType | PositionsType | null)[]
export function fromOptimik3ToJson(data: string): ParseResult {
    data = data.trim()
    let multilineString = false
    let parser: undefined | ((val: string) => OrderType | OrderProductType | PositionsType | null) = undefined;
    let ignoreAllIvalidState = false;
    let row = "";
    let parseResult: ParseResult = [];
    for (const line_raw of data.split("\r\n")) {
        const line = line_raw.trim()
        if (line === Zlecenia) {
            executeParser();
            row = "";
            ignoreAllIvalidState = false;
            parser = stringToOrder;
            continue;
        } else if (line === ZleceniaProdukt) {
            executeParser();
            row = "";
            ignoreAllIvalidState = false;
            parser = stringToOrderProduct;
            continue;
        } else if (line === Pozycje) {
            executeParser();
            row = "";
            ignoreAllIvalidState = false;
            parser = stringToPositions;
            continue;
        } else if (line.startsWith("[~") && line.endsWith("~]")) {
            console.warn("WARNING: Unknown section: ", row)
            row = "";
            ignoreAllIvalidState = true;
            continue;
        }
        if (ignoreAllIvalidState) {
            continue
        }
        if (!line.includes(";") && !multilineString) { // just blank comment line
            continue
        }
        if (line.search(";\"") !== -1) {
            multilineString = true;
            row += line;
        } else if (line.search("\";") !== -1) { // this is not 100% reliable - if multiline string is last element it will fail
            multilineString = false;
            row += line;
        }
        if (line.includes(";")) {
            row += line;
        } else {
            console.warn("shoud not happen", row);
        }
    }
    if (parser) {
        if (!row) console.warn("Using parser but row is empty")
        parseResult.push(parser(row));
    }
    // console.log("parseResult: ")
    // console.log(parseResult)
    return parseResult;

    function executeParser() {
        if (parser) {
            console.debug("using ", parser, " to parse row: ", row)
            if (!row) console.log("Using parser but row is empty");
            parseResult.push(parser(row));
        }
    }
}

export function fromOptimikToFormData(data: string): FormData {
    const parseResult = fromOptimik3ToJson(data)
    let form: FormData = { address: "", city: "", email: "", name: "", nip: "", postalCode: "", products: [], summary: "", };
    let lastProduct: ProductData | null = null
    for (const item of parseResult) {
        if (!item) {
            continue
        }
        if (isOrderType(item)) {
            // recoverUserDataFromDescription - best effort
            const description = item.description.split("\n").slice(0, -3)
            const lines = item.description.split("\n").slice(-3)
            const name = lines.at(0) || "";
            const [email, nip] = lines.at(1)?.split(",") || ["", ""];
            const [postalCode, address] = lines.at(2)?.split(",") || ["", ""];
            form.name = name || "";
            form.email = email || "";
            form.postalCode = postalCode || "";
            form.address = address || "";
            form.nip = nip || "";
            form.summary = "Aktualizacja dla zamówienia: " + item.name + "\n" + description.join("\n")
        } else if (isOrderProductType(item)) {
            lastProduct = {
                productName: item.name,
                amount: item.number_of_elements,
                sheets: []
            };
            form.products.push(lastProduct)
        } else if (isPositionsType(item)) {
            if (lastProduct === null) { continue; }
            const sheetForm: SheetData = {
                itemName: item.name,
                itemComment: item.description,
                materialCode: item.code,
                length: item.length,
                width: item.width,
                useGrain: item.keep_graining,
                amount: item.number,
                edgeLeft: { edgeCode: item.code_for_edge_B },
                edgeRight: { edgeCode: item.code_for_edge_D },
                edgeUp: { edgeCode: item.code_for_edge_A },
                edgeDown: { edgeCode: item.code_for_edge_C },
            };
            lastProduct.sheets.push(sheetForm);
        } else {
            console.log("ERROR: unhandled " + item)
        }

    }
    return form;

}

function stringToOrder(row: string): OrderType | null {
    const items = row.split(";")
    const order: OrderType = {
        _type: Order,
        number: fromOptimikString(items[0]),
        date: fromOptimikString(items[1]),
        name: fromOptimikString(items[2]),
        description: fromOptimikString(items[3]),
        undocumentedField: fromOptimikString(items[4]),
        dueDate: fromOptimikString(items[5]),
        discount: fromOptimikNumber(items[6]),
        businessPartnerAddress: fromOptimikString(items[7]),
        status: fromOptimikNumber(items[8]),
        isDeadlineSet: fromOptimikBoolean(items[9]),
    };
    // console.log("stringToOrder")
    // console.log(items.map((v, i) => i + "=" + v))
    return order;
}

function stringToOrderProduct(row: string): OrderProductType | null {
    const items = row.split(";")
    const orderProduct: OrderProductType = {
        _type: OrderProduct,
        code: fromOptimikString(items[0]),
        name: fromOptimikString(items[1]),
        description: fromOptimikString(items[2]),
        number_of_elements: fromOptimikNumber(items[3]),
        price: fromOptimikNumber(items[4]),
        automatic_price: fromOptimikBoolean(items[5]),
        different_orders: fromOptimikBoolean(items[6]),
        weight_export_only: fromOptimikNumber(items[7]),
    }
    // console.log("stringToOrderProduct:")
    // console.log(items.map((v, i) => i + "=" + v))
    return orderProduct;

}
function stringToPositions(row: string): PositionsType | null {
    const items = row.split(";")
    const sheet: PositionsType = {
        _type: Positions,
        code: fromOptimikString(items[0]),
        accessory_code: fromOptimikString(items[1]),
        magazine_product_code: fromOptimikString(items[2]),
        name: fromOptimikString(items[3]),
        description: fromOptimikString(items[4]),
        number: fromOptimikNumber(items[5]),
        keep_graining: fromOptimikBoolean(items[6]),
        length: fromOptimikNumber(items[7]),
        width: fromOptimikNumber(items[8]),

        code_for_edge_A: fromOptimikString(items[9]),
        accessory_code_edge_A: fromOptimikString(items[10]),
        export_only_thickness_edge_A: fromOptimikNumber(items[11]),
        code_for_edge_B: fromOptimikString(items[12]),
        accessory_code_edge_B: fromOptimikString(items[13]),
        export_only_thickness_edge_B: fromOptimikNumber(items[14]),
        code_for_edge_C: fromOptimikString(items[15]),
        accessory_code_edge_C: fromOptimikString(items[16]),
        export_only_thickness_edge_C: fromOptimikNumber(items[17]),
        code_for_edge_D: fromOptimikString(items[18]),
        accessory_code_edge_D: fromOptimikString(items[19]),
        export_only_thickness_edge_D: fromOptimikNumber(items[20]),

        additional_thickness: fromOptimikNumber(items[21]),
        external_CNC_command: fromOptimikString(items[22]),
        // null, Undocumented? item[23] skipped
        do_not_match_element_dimensions: fromOptimikBoolean(items[24]),
        export_only_thickness_width: fromOptimikNumber(items[25]),
        drawing: fromOptimikString(items[26]),
        package_number: fromOptimikNumber(items[27]),
        accessory_code_1: fromOptimikString(items[28]),
        accessory_1_package_number: fromOptimikNumber(items[29]),
        number_of_accessory_code_1: fromOptimikNumber(items[30]),
        accessory_code_2: fromOptimikString(items[31]),
        number_of_accessory_code_2: fromOptimikNumber(items[32]),
        accessory_2_package_number: fromOptimikNumber(items[33]),
    }
    // console.log("stringToPosition:")
    // console.log(items.map((v, i) => i + "=" + v))
    return sheet;

}